var map = {
	"./applications": 15897,
	"./applications.vue": 15897,
	"./catalogservices": 54371,
	"./catalogservices.vue": 54371
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52612;
module.exports = webpackAsyncContext;